// extracted by mini-css-extract-plugin
module.exports = {"title":"PostItem-module--title--2pVSN","date":"PostItem-module--date--5iBTS"};